import http from '../http'
// 查询根据vipCode查询启用的VIP会员-CMS通用文件信息
export function listCmsVipCommonFileByVipCode(params) {
  return http({
    url: `/api/cms/openwebsite/listCmsVipCommonFileByVipCode`,
    method: 'get',
    params,
    loading: false
  })
}



// WEBPACK FOOTER //
// ./src/api/vip/commonFileApi.js